import { render, staticRenderFns } from "./SubjectNotes.vue?vue&type=template&id=a5363ea8"
import script from "./SubjectNotes.vue?vue&type=script&lang=ts"
export * from "./SubjectNotes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports